export const addtohotels=(data)=>({
    type:"ADD_TO_HOTELS",
    payload:data,
})